// PrivacyPolicy.js
import React from 'react';
import styled from 'styled-components';

// Styled Components
const Container = styled.div`
  max-width: 900px;
  margin: 5px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
`;

const Title = styled.h1`
  text-align: center;
  color: #333;
  margin-bottom: 10px;
`;

const SubTitle = styled.h2`
  text-align: center;
  color: #666;
  margin-bottom: 30px;
  font-weight: 400;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
  color: #444;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 10px;
`;

const List = styled.ul`
  list-style-type: disc;
  margin-left: 20px;
  color: #555;
`;

const ListItem = styled.li`
  margin-bottom: 5px;
`;

// Privacy Policy Component
const PrivacyPolicy = () => {
  return (
    <Container>
      <Title>Privacy Policy</Title>
      <Paragraph>Last updated: [Date]</Paragraph>

      <Section>
        <SectionTitle>i. Introduction</SectionTitle>
        <Paragraph>
          Colab Kitchen ("we", "our", or "us") is committed to protecting your
          privacy. This Privacy Policy explains how we collect, use, disclose, and
          safeguard your information when you visit our website colab.kitchen and
          use our services.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>ii. Information We Collect</SectionTitle>
        <Paragraph>
          We collect information that you provide directly to us, such as when you
          create an account, place an order, or contact us. This may include:
        </Paragraph>
        <List>
          <ListItem>Personal information (e.g., name, email address, phone number)</ListItem>
          <ListItem>Payment information</ListItem>
          <ListItem>Dietary preferences and restrictions</ListItem>
          <ListItem>User-generated content (e.g., reviews, comments)</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>iii. How We Use Your Information</SectionTitle>
        <List>
          <ListItem>Provide, maintain, and improve our services</ListItem>
          <ListItem>Process transactions and send related information</ListItem>
          <ListItem>Communicate with you about our services</ListItem>
          <ListItem>Respond to your comments, questions, and requests</ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>iv. Information Sharing and Disclosure</SectionTitle>
        <Paragraph>We may share your information with:</Paragraph>
        <List>
          <ListItem>Cooks to fulfill your orders</ListItem>
          <ListItem>Service providers who perform services on our behalf</ListItem>
          <ListItem>
            Law enforcement or other parties when required by law or to protect our rights
          </ListItem>
        </List>
      </Section>

      <Section>
        <SectionTitle>v. Data Security</SectionTitle>
        <Paragraph>
          We implement appropriate technical and organizational measures to protect your
          personal information.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>vi. Your Rights</SectionTitle>
        <Paragraph>
          You have the right to access, correct, or delete your personal information.
          Please contact us to exercise these rights.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>vii. Changes to This Privacy Policy</SectionTitle>
        <Paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any
          changes by posting the new Privacy Policy on this page.
        </Paragraph>
      </Section>
    </Container>
  );
};

export default PrivacyPolicy;
